import React from 'react'
import styled from 'styled-components'
import { TableHead } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import { ArrowDropUp } from '@material-ui/icons'
import {
  colors,
  svgIconStyle
} from '../../../theme/Global'

export const CustomTableHead = styled(TableHead)`
  background-color: ${colors.darkGrey};
`

export const CustomArrowUp = (
  <ArrowDropUpIcon
    style={svgIconStyle({
      color: colors.white,
      height: '24px',
      width: '24px'
    })}
  />
)

export const CustomArrowDown = (
  <ArrowDropDownIcon
    style={svgIconStyle({
      color: colors.white,
      height: '24px',
      width: '24px'
    })}
  />
)

export const SortWrapper = styled.span`
  position: relative;
  display: inline-block;
  top: 7px;
  && svg {
    position: absolute;
    top: -20px;
    height: 18px !important;
    width: 18px !important;
  }
`

export const FilterWrapper = styled.span`
  position: relative;
  display: inline-block;
  top: 7px;
  && svg {
    position: absolute;
    top: -20px;
    height: 18px !important;
    width: 18px !important;
  }
`

export const PaginationArrow = styled(ArrowDropUp)`
  height: 16px;
  ${(props) => (props.direction === 'right'
    ? 'transform: translateY(4px) rotate(-90deg);'
    : 'transform: translateY(4px) rotate(90deg);')}
  position: relative;
  top: 2px;
  width: 16px;
`

export const TableHeaderTooltipIcon = styled.span`
  display: inline-block;
  position: relative;
  top: 3px;
  padding-left: 1rem;
`
